import React, { Suspense, useState } from 'react';
import LazyLoad, { lazyload } from 'react-lazyload';
import { Lottie } from '@crello/react-lottie';

import Head from 'next/head';

import st from './index.module.scss';

import Pricing from '../../../components/video-production/Pricing';
import BradCrumbs from '../../../components/Base/BradCrumbs';
import Engagement from '../../../components/Engagement';
import Faq from '../../../components/Faq';
import typesLottie from '../../../public/images/types.json';
import Why from '../../../components/Why';
import ViewMore from '../../../components/ViewMore';
import BenefitsStartup from '../../../components/video-production/explainer-videos/BenefitsStartup';
import ProcessSliderStartup from '../../../components/sliders/ProcessSliderStartup';
import SolveProblemsStartup from '../../../components/video-production/explainer-videos/SolveProblemsStartup';

lazyload({
  width: '100%',
});

const ExplainerVideosStartup = props => {
  const [showPricingModalF, setShowPricingModalF] = useState(false);
  const [videoLength, setVideoLength] = useState([]);
  const [script, setScript] = useState([]);

  const showPricingModal = () => {
    if (props.width < 768) {
      window.location.href = '/video-production/get-pricing';
    } else {
      setShowPricingModalF(true);
      document.body.style.overflow = 'hidden';
      document.documentElement.style.overflow = 'hidden';
      window.location.hash = 'open';
    }
  };
  const hidePricingModal = () => {
    setShowPricingModalF(false);
    document.body.style.overflow = 'auto';
    document.body.style.overflowX = 'hidden';
    history.replaceState(null, null, ' ');
    document.documentElement.style.overflow = 'auto';
  };

  return (
    <>
      <Head>
        <title>Video Production - Startup Explainer Video | Prodigi</title>
        <link rel="alternate" hrefLang="en" href="https://weprodigi.com/video-production/startup-explainer-video" />
        <meta
          name="description"
          content="Discover the enchantment of startups with our tailored explainer video! Witness how our services ignite your business. Dive in for a transformative journey!"
        />
        <meta property="og:url" content="https://weprodigi.com/video-production/startup-explainer-video" />
        <meta property="og:type" content="article" />
        <meta property="og:title" content="Video Production - Startup Explainer Video | Prodigi" />
        <meta
          property="og:description"
          content="Discover the enchantment of startups with our tailored explainer video! Witness how our services ignite your business. Dive in for a transformative journey!"
        />
        <meta property="og:image" content="https://weprodigi.com/uploads/images/explainer-videos/startup-explainer/og.jpg" />
        <script
          type="application/ld+json"
          className="organization-schema"
          dangerouslySetInnerHTML={{
            __html: `{
  "@context": "http://schema.org",
  "@type": "WebPage",
  "name": "Video Production - Startup Explainer Video | Prodigi",
  "description": "Discover the enchantment of startups with our tailored explainer video! Witness how our services ignite your business. Dive in for a transformative journey!",
  "url": "https://weprodigi.com/video-production/startup-explainer-video",
  "breadcrumb": {
    "@type": "BreadcrumbList",
    "itemListElement": [
      {
        "@type": "ListItem",
        "position": 1,
        "name": "Home",
        "item": "https://weprodigi.com"
      },
      {
        "@type": "ListItem",
        "position": 2,
        "name": "Full Service Video Production",
        "item": "https://weprodigi.com/video-production"
      },
      {
        "@type": "ListItem",
        "position": 3,
        "name": "Startup Explainer Video Production",
        "item": "https://weprodigi.com/video-production/startup-explainer-video"
      }
    ]
  },
  "mainEntity": {
    "@type": "Product",
    "name": "Startup Explainer Video Production",
    "description": "Discover the enchantment of startups with our tailored explainer video! Witness how our services ignite your business. Dive in for a transformative journey!",
    "brand": {
      "@type": "Brand",
      "name": "Weprodigi"
    },
    "offers": {
      "@type": "Offer",
      "price": "1300",
      "priceCurrency": "USD",
      "seller": {
        "@type": "Organization",
        "name": "Weprodigi"
      }
    },
    "image": "https://weprodigi.com/images/logovertical.svg",
    "review": [
      {
        "@type": "Review",
        "reviewRating": {
          "@type": "Rating",
          "ratingValue": "5",
          "bestRating": "5",
          "worstRating": "1"
        },
        "author": {
          "@type": "Person",
          "name": "Scarlett Marley"
        },
        "datePublished": "2024-03-03",
        "reviewBody": "Their explainer videos are pure magic! They perfectly captured our startup's essence and conveyed it in a captivating way. A game-changer for our brand!"
      },
      {
        "@type": "Review",
        "reviewRating": {
          "@type": "Rating",
          "ratingValue": "5",
          "bestRating": "5",
          "worstRating": "1"
        },
        "author": {
          "@type": "Person",
          "name": "Daniel Kiz"
        },
        "datePublished": "2024-02-21",
        "reviewBody": "Prodigi's explainer videos are top-notch! They skillfully showcased our startup's story, boosting our brand recognition immensely. Highly recommend their services!"
      },
      {
        "@type": "Review",
        "reviewRating": {
          "@type": "Rating",
          "ratingValue": "4.9",
          "bestRating": "5",
          "worstRating": "1"
        },
        "author": {
          "@type": "Person",
          "name": "Victoria Austin"
        },
        "datePublished": "2024-02-06",
        "reviewBody": "Their creativity and attention to detail brought our vision to life, leaving a lasting impression on our audience. Truly exceptional work!"
      }
    ],
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.9",
      "reviewCount": "3"
    }
  }
} `,
          }}
        />
      </Head>

      {/*    Header video */}
      <div className={`relative w-full  h-intro  overflow-hidden  `}>
        <video
          width="100%"
          height="100%"
          autoPlay
          loop
          muted
          playsInline
          preload="none"
          id="header-11"
          className={'absolute h-intro md:h-full ' + st['header-mp4']}
        >
          <source src="https://weprodigi.com/uploads/images/explainer-videos/startup-explainer/startup-explainer.mp4" type="video/mp4" />
        </video>
        <div className={st['overlay']}></div>
        <div className="container h-full">
          <div className="relative h-full  flex flex-col flex-wrap justify-center items-start overflow-hidden">
            <h1 className="max-w-300 md:max-w-600 uppercase md:normal-case text-white text-30 md:text-72 font-black md:font-bold leading-tight">
              Startup Explainer Video Production
            </h1>
            <a
              onClick={showPricingModal}
              className="relative flex items-center justify-center min-w-250 z-10 border-2 rounded-5 border-green-badge hover:border-green-hover text-18 text-white px-23 mt-48 md:mt-23 py-8 bg-green-badge hover:bg-green-hover hover:text-white transition-all   transition-400 cursor-pointer"
            >
              Get Pricing
              <img src="https://weprodigi.com/uploads/images/explainer-videos/buttonIcon.svg" className={'ml-10'} alt="pricing icon" />
            </a>
          </div>
        </div>
      </div>

      <div className="bg-white">
        <div className="container">
          <BradCrumbs
            items={[
              {
                url: '/video-production',
                name: 'Video Production',
              },
              {
                url: '/video-production/explainer-videos',
                name: 'Explainer Video Production',
              },
              {
                url: '/video-production/startup-explainer-video',
                name: 'Startup Explainer Video',
              },
            ]}
          />
          <div className="relative pt-20 md:pt-0 pb-48">
            <div className="flex flex-wrap md:flex-nowrap justify-between">
              <LazyLoad className="mr-auto mt-24 md:mt-0 max-w-270 w-full md:w-auto" height={200} once>
                <Lottie
                  config={{
                    animationData: typesLottie,
                    loop: true,
                    autoPlay: true,
                  }}
                  playingState="playing"
                />
              </LazyLoad>
              <div className="flex flex-col ml-12 items-center justify-center max-w-756">
                <Engagement title="Video">
                  A startup explainer video will provide your impressive entrance into the market. The engaging video content gives a reliable start.
                  Make sure everyone knows about your startup. Scroll down to know how.
                </Engagement>
              </div>
            </div>
          </div>
        </div>
      </div>

      <LazyLoad height={200} once>
        <div className={'bg-gray-white py-24'}>
          <div className="container">
            <h2 className={'w-full lg:w-half-auto font-bolder text-24 md:text-36 leading-28 md:leading-44 uppercase text-black'}>
              What Is a Startup Explainer Video?
            </h2>

            <div className={'block md:flex justify-between flex-row md:flex-row-reverse'}>
              <div className=" pl-0 md:pl-20 pb-10 w-full md:w-half-auto block  mt-23 mb-10">
                <LazyLoad height={315} offset={100}>
                  <iframe
                    width="560"
                    height="315"
                    className="w-full"
                    src="https://www.youtube.com/embed/AAAnoo0NYpc?controls=0"
                    title="YouTube video player"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowFullScreen
                  ></iframe>
                </LazyLoad>
                <p className={'font-medium text-14 leading-24 text-center mt-8 text-gray-dark'}>Scoutely | Startup Explainer Video</p>
              </div>

              <p className={'mt-20 w-half-auto hidden md:block'}>
                Do you want to make a lasting first impression as a new business? A startup explainer video is what you need! It showcases your
                innovative solutions and benefits. Visual storytelling simplifies complex ideas about your startup. As a result, you get a good spot
                in the market.
              </p>
              <div className={'mt-20 block md:hidden'}>
                <ViewMore ln={40}>
                  Do you want to make a lasting first impression as a new business? A startup explainer video is what you need! It showcases your
                  innovative solutions and benefits. Visual storytelling simplifies complex ideas about your startup. As a result, you get a good spot
                  in the market.
                </ViewMore>
              </div>
            </div>
            <br className={'clear-both hidden'} />
          </div>
        </div>
      </LazyLoad>

      <LazyLoad height={200} once>
        <div className={'bg-white py-24'}>
          <div className="container">
            <h2 className={'w-full md:w-75p font-bolder text-24 md:text-36 leading-28 md:leading-44 uppercase text-black'}>
              Where to Use a Startup Explainer Video?
            </h2>
            <p className={'mt-20'}>
              According to statistics, only 10% of startups succeed from the first steps. What do they do that doesn't do the rest? The answer is
              simple: they connect with the audience directly. Startup explainer videos are the best solution in this matter. Here's how they can help
              you in your field.
            </p>

            <div className="flex flex-wrap-reverse md:flex-nowrap justify-between items-start mt-0 md:mt-24">
              <div className={'w-full md:w-half-auto mt-24 md:mt-0 '}>
                <LazyLoad height={315} offset={100}>
                  <iframe
                    width="560"
                    height="315"
                    className="w-full"
                    src="https://www.youtube.com/embed/XZKqIfBgvRQ?controls=0"
                    title="YouTube video player"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowFullScreen
                  ></iframe>
                </LazyLoad>
                <p className={'font-medium text-14 leading-24 text-center mt-8 text-gray-dark'}>MAIX | Startup Explainer Video</p>
              </div>

              <div className={'w-full md:w-half-auto mt-24 md:mt-0'}>
                <h3 className="text-purple font-bold text-24   leading-none">Marketing and Advertising</h3>
                <div className={'mt-16 hidden md:block'}>
                  Looking for a short way to your place in the market? Improve your marketing strategy with an explainer video for startup. Explainer
                  videos for businesses will take over social media with their shareability. They will communicate with the ones who share the same
                  values as you. Show everyone that your solution is what they need. Enhance interest and engagement in your startup. Also, provide
                  the main messages and stand out from competitors. Use video marketing for startups on various platforms and support your customers
                  effectively.
                </div>
                <div className={'mt-16 block md:hidden'}>
                  <ViewMore ln={40}>
                    Looking for a short way to your place in the market? Improve your marketing strategy with an explainer video for startup.
                    Explainer videos for businesses will take over social media with their shareability. They will communicate with the ones who share
                    the same values as you. Show everyone that your solution is what they need. Enhance interest and engagement in your startup. Also,
                    provide the main messages and stand out from competitors. Use video marketing for startups on various platforms and support your
                    customers effectively.
                  </ViewMore>
                </div>
              </div>
            </div>

            <div className="flex flex-wrap md:flex-nowrap justify-between mt-0 md:mt-48">
              <div className={'w-full md:w-half-auto mt-24 md:mt-0 '}>
                <h3 className="text-purple font-bold text-24 leading-none">Technology and Software </h3>
                <p className={'mt-16'}></p>

                <p className={'mt-16 hidden md:block'}>
                  Do you aim to present your innovative technological solutions to a wide audience? Add an explainer video for startup to your
                  marketing, sales, and support strategies. Simplify complex ideas, demonstrate product value, and support customers to get the most
                  out of your offering. Customer satisfaction is the key to long-term business success. And that is what every startup wants.
                </p>
                <div className={'mt-16 block md:hidden'}>
                  <ViewMore ln={40}>
                    Do you aim to present your innovative technological solutions to a wide audience? Add an explainer video for startup to your
                    marketing, sales, and support strategies. Simplify complex ideas, demonstrate product value, and support customers to get the most
                    out of your offering. Customer satisfaction is the key to long-term business success. And that is what every startup wants.
                  </ViewMore>
                </div>
              </div>
              <div className={'w-full md:w-half-auto mt-24 md:mt-0 '}>
                <LazyLoad height={315} offset={100}>
                  <iframe
                    width="560"
                    height="315"
                    className="w-full"
                    src="https://www.youtube.com/embed/H5qU0YY5v84?controls=0"
                    title="YouTube video player"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowFullScreen
                  ></iframe>
                </LazyLoad>
                <p className={'font-medium text-14 leading-24 text-center mt-8 text-gray-dark'}>Project Agora | Software Solution Explainer Video</p>
              </div>
            </div>
            <div className="flex flex-wrap-reverse md:flex-nowrap justify-between mt-24 md:mt-48">
              <div className={'w-full md:w-half-auto mt-24 md:mt-0 '}>
                <LazyLoad height={315} offset={100}>
                  <iframe
                    width="560"
                    height="315"
                    className="w-full"
                    src="https://www.youtube.com/embed/uV2JsS1vQ-w?controls=0"
                    title="YouTube video player"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowFullScreen
                  ></iframe>
                </LazyLoad>
                <p className={'font-medium text-14 leading-24 text-center mt-8 text-gray-dark'}>SimplyPayMe | Financial Software Explainer Video</p>
              </div>

              <div className={'w-full md:w-half-auto '}>
                <h3 className="text-purple font-bold text-24 leading-none">Finance and Banking</h3>
                <p className={'mt-16 hidden md:block'}>
                  The main challenge of a financial startup is the trust of the customer. Build that trust with a simple and engaging startup
                  explainer video. It turns complex financial topics into a catchy story, highlighting the unique benefits of your product that will
                  add new value to the viewer's life. The simple language and attractive visual video style drive high engagement. Each potential
                  customer gets a unique visual experience that they will never forget.
                </p>
                <div className={'mt-16 block md:hidden'}>
                  <ViewMore ln={'40'}>
                    The main challenge of a financial startup is the trust of the customer. Build that trust with a simple and engaging startup
                    explainer video. It turns complex financial topics into a catchy story, highlighting the unique benefits of your product that will
                    add new value to the viewer's life. The simple language and attractive visual video style drive high engagement. Each potential
                    customer gets a unique visual experience that they will never forget.
                  </ViewMore>
                </div>
              </div>
            </div>
          </div>
        </div>
      </LazyLoad>

      <LazyLoad height={200} once>
        <div className={'bg-gray-light py-24'}>
          <div className="container">
            <h2 className={'w-full font-bolder text-24 md:text-36 leading-28 md:leading-44 uppercase text-black'}>
              Benefits of Startup Explainer Videos
            </h2>
            <p className={'mt-20'}>
              Trying to find something that can be useful for your startup? Try your story! Visualisation of your startup story can make a strong
              connection with your potential customers. Learn more about the benefits of startup video production.
            </p>
            <Suspense fallback={`Loading...`}>
              <BenefitsStartup />
            </Suspense>
          </div>
        </div>
      </LazyLoad>

      <LazyLoad height={200} once>
        <div className="bg-white">
          <div className="container py-23">
            <h2 className="text-purple text-24 md:text-36 text-left mb-23 font-black uppercase leading-none">
              Our Startup Explainer Video Production Process
            </h2>
            <ProcessSliderStartup />
          </div>
        </div>
      </LazyLoad>

      <LazyLoad height={0} once>
        <div className={'h-500 md:h-310 overflow-hidden relative ' + st['bg-contact']}>
          <div id="stars" />
          <div id="stars2" />
          <div id="stars3" />
          <div className="container flex flex-wrap md:flex-nowrap justify-between items-end md:items-center h-full ">
            <div
              className={
                'mt-24 md:mt-0 text-left md:text-center font-bold uppercase  text-white leading-28 md:leading-44   text-20 md:text-26 lg:text-36'
              }
            >
              CALCULATE YOUR STARTUP EXPLAINER VIDEO PRICE
              <br />
              <span className={'pt-20 font-normal normal-case text-18 md:text-24 leading-20 md:leading-29 '}>
                Answer five questions and get to know the price!
              </span>
              <div className={'flex justify-end md:justify-center mt-0 leading-0'}>
                <button
                  onClick={showPricingModal}
                  className="uppercase h-40 text-18 leading-24  hover:bg-green-hover md:flex justify-center items-center   w-auto mt-24 text-white bg-green rounded-5 px-23 py-0 md:py-5"
                >
                  Start Now
                </button>
              </div>
            </div>
            <img src="https://weprodigi.com/uploads/images/explainer-videos/Inga.webp" alt="eva" className={st['inga']} />
          </div>
        </div>
      </LazyLoad>

      <LazyLoad height={200} once>
        <div className={'bg-white py-24'}>
          <div className="container">
            <h2 className={'w-full font-bolder text-24 md:text-36 leading-28 md:leading-44 uppercase text-black'}>
              How Startup Explainer Video Can Help Your Business?
            </h2>
            <p className={'mt-20'}>
              A startup is already making interest. But is that enough? Startup explainer video is the adjustment that you need.
            </p>
            <Suspense fallback={`Loading...`}>
              <SolveProblemsStartup />
            </Suspense>
          </div>
        </div>
      </LazyLoad>

      <LazyLoad height={200} once>
        <div className="bg-gray-light">
          <div className="container py-23">
            <h2 className="uppercase text-30 md:text-36 mb-23 font-black text-purple leading-none">
              Why Choose Us for Your Startup Explainer Video Production?
            </h2>
            <Why
              content={[
                {
                  title: 'We value your time.',
                  answer:
                    "We know how important our clients' time is. Outsourcing full-service video production helps save your expensive time. More importantly, we quickly understand your business needs and implement our proven time-saving solutions at all stages of production, from communication to payment methods.",
                },
                {
                  title: 'We include digital marketing specialists in the production process.',
                  answer:
                    "According to Google, 6 out of 10 people prefer watching videos online rather than TV. To create an effective video, you need to consider which platform the video will be used on and master all its features, be it your website, YouTube, Facebook, or Amazon. That's why we include our digital marketing specialists in the production process, who study your business requirements in detail and combine them with the requirements of each online platform to get effective material.",
                },
                {
                  title: "We don't require prepayment.",
                  answer:
                    "The client should pay for the work rather than with deposits. We chose a milestone payment option as it's a more trustworthy approach to our work.",
                },
                {
                  title: "We don't have a single unhappy client.",
                  answer:
                    'We never charge for a product that you have not approved. If you are unsatisfied with the results, 100% money-back is guaranteed.',
                },
              ]}
            />
          </div>
        </div>
      </LazyLoad>

      <LazyLoad height={200} once>
        <div className="bg-white">
          <div className="container py-23">
            <h2 className="uppercase text-24 md:text-36 mb-23 font-black text-purple leading-none">FAQ</h2>
            <div className="grid md:grid-cols-2 md:gap-30">
              <Faq
                content={[
                  {
                    title: 'Why explainer videos are essential for startup success?',
                    answer: 'Explainer videos help your startup to convince people to learn more and trust it.',
                  },
                  {
                    title: 'Are explainer videos only useful for B2C startups, or can B2B startups benefit as well?',
                    answer:
                      'Explainer videos are beneficial for both B2C and B2B startups, helping simplify complex concepts, engage stakeholders, and improve communication and marketing efforts.',
                  },
                ]}
              />
              <Faq
                content={[
                  {
                    title: 'How can startups promote their explainer videos effectively?',
                    answer:
                      'Startups can promote their explainer videos effectively by leveraging multiple platforms and techniques to reach their target audience.',
                  },
                  {
                    title: 'How long should a startup explainer video be?',
                    answer: 'As a rule, a startup explainer video lasts from 30 seconds to 3 minutes.',
                  },
                ]}
              />
            </div>
          </div>
        </div>
      </LazyLoad>

      <Pricing videoLength={videoLength} script={script} country={props.country} show={showPricingModalF} hide={hidePricingModal} step={1} />
    </>
  );
};

export default ExplainerVideosStartup;
